"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _callSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/callSuper"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _Button = _interopRequireDefault(require("../Button"));
var _DoneIcon = _interopRequireDefault(require("../../svg/DoneIcon"));
var _CloseIcon = _interopRequireDefault(require("../../svg/CloseIcon"));
var _context3 = _interopRequireDefault(require("../Color/context"));
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _CheckboxBase = _interopRequireDefault(require("./CheckboxBase"));
var _excluded = ["children", "active", "disabled", "color", "size", "variant", "effect", "ref", "classNames", "getSwitchIconParentButtonProps", "getSwitchIconButtonProps"],
  _excluded2 = ["children", "active", "disabled", "size", "variant", "color"],
  _excluded3 = ["MenuItemComponent", "active", "color", "effect", "switchClassNames", "switchIconToEnd", "getSwitchIconButtonProps", "getSwitchIconParentButtonProps"],
  _excluded4 = ["MenuItemProps", "MenuItemComponent", "classNames", "checkboxIconToEnd", "switchIconToEnd", "getSwitchIconButtonProps", "getSwitchIconParentButtonProps"];
var SwitchIcon = /*#__PURE__*/function (_Component) {
  function SwitchIcon(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, SwitchIcon);
    _this = (0, _callSuper2["default"])(this, SwitchIcon, [props]);
    _this.state = {
      update: 1
    };
    _this.containerRef = /*#__PURE__*/(0, _react.createRef)();
    _this.buttonRef = /*#__PURE__*/(0, _react.createRef)();
    _this.buttonContainerRef = /*#__PURE__*/(0, _react.createRef)();
    _this._active = /*#__PURE__*/(0, _react.createRef)();
    _this.containerRef.current = {};
    _this.buttonRef.current = {};
    _this.buttonContainerRef.current = {};
    _this._active.current = {
      value: !!props.active
    };
    _this.waitBeforeRender = props.waitBeforeRender || 200;
    return _this;
  }
  (0, _inherits2["default"])(SwitchIcon, _Component);
  return (0, _createClass2["default"])(SwitchIcon, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return nextState.update !== this.state.update;
    }
  }, {
    key: "getClassName",
    value: function getClassName(active) {
      var _this$props = this.props,
        classNames = _this$props.classNames,
        className = _this$props.className;
      return (0, _clsx2["default"])(classNames.switchIcon, (0, _defineProperty2["default"])({}, classNames.switchIconActive, active), className);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var effect = this.props.effect;
      if (effect) {
        effect({
          actions: {
            setActive: function () {
              var _setActive = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(value) {
                var _this2$buttonRef$curr, _this2$buttonRef$curr2, _this2$buttonContaine, _this2$buttonContaine2;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      if (!(_this2._active.current.value !== !!value)) {
                        _context.next = 13;
                        break;
                      }
                      _this2._active.current.value = !!value;
                      if (_this2.containerRef.current) {
                        _this2.containerRef.current.className = _this2.getClassName(_this2._active.current.value);
                      }
                      if (!((_this2$buttonRef$curr = _this2.buttonRef.current) !== null && _this2$buttonRef$curr !== void 0 && (_this2$buttonRef$curr2 = _this2$buttonRef$curr.actions) !== null && _this2$buttonRef$curr2 !== void 0 && _this2$buttonRef$curr2.setActive)) {
                        _context.next = 6;
                        break;
                      }
                      _context.next = 6;
                      return _this2.buttonRef.current.actions.setActive(!!value);
                    case 6:
                      if (!((_this2$buttonContaine = _this2.buttonContainerRef.current) !== null && _this2$buttonContaine !== void 0 && (_this2$buttonContaine2 = _this2$buttonContaine.actions) !== null && _this2$buttonContaine2 !== void 0 && _this2$buttonContaine2.setActive)) {
                        _context.next = 9;
                        break;
                      }
                      _context.next = 9;
                      return _this2.buttonContainerRef.current.actions.setActive(!!value);
                    case 9:
                      _context.next = 11;
                      return new Promise(function (resolve) {
                        return setTimeout(resolve, _this2.waitBeforeRender);
                      });
                    case 11:
                      _context.next = 13;
                      return _this2.setState({
                        update: _this2.state.update + 1
                      });
                    case 13:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function setActive(_x) {
                return _setActive.apply(this, arguments);
              }
              return setActive;
            }()
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this,
        _this$_active$current;
      var _this$props2 = this.props,
        children = _this$props2.children,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        color = _this$props2.color,
        size = _this$props2.size,
        variant = _this$props2.variant,
        effect = _this$props2.effect,
        _ref3 = _this$props2.ref,
        classNames = _this$props2.classNames,
        getSwitchIconParentButtonProps = _this$props2.getSwitchIconParentButtonProps,
        getSwitchIconButtonProps = _this$props2.getSwitchIconButtonProps,
        rest = (0, _objectWithoutProperties2["default"])(_this$props2, _excluded);
      var defaultButtonProps = {
        Component: 'div',
        size: 'checkbox-' + size.split('-')[1],
        variant: ['contained', 'outlined'].indexOf(variant) > -1 ? variant : 'contained',
        color: disabled ? 'disabled' : color,
        style: disabled ? {
          pointerEvents: 'none'
        } : {},
        active: active
      };
      return /*#__PURE__*/_react["default"].createElement("div", Object.assign({}, rest, {
        ref: function ref(e) {
          _this3.containerRef.current = e;
          if (_ref3) {
            if (typeof _ref3 === 'function') {
              _ref3(e);
            } else if (_ref3 && typeof _ref3 === 'object') {
              _ref3.current = e;
            }
          }
        },
        className: this.getClassName((_this$_active$current = this._active.current) === null || _this$_active$current === void 0 ? void 0 : _this$_active$current.value)
      }), /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({}, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultButtonProps), getSwitchIconParentButtonProps ? getSwitchIconParentButtonProps({
        defaultButtonProps: defaultButtonProps,
        active: active,
        disabled: disabled,
        size: size,
        variant: variant,
        color: color
      }) : {}), {
        effect: function effect(p) {
          var actions = p.actions;
          _this3.buttonContainerRef.current.actions = actions;
        },
        ButtonBaseContentComponent: function ButtonBaseContentComponent() {
          return /*#__PURE__*/_react["default"].createElement(_Button["default"], Object.assign({}, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultButtonProps), getSwitchIconButtonProps ? getSwitchIconButtonProps({
            defaultButtonProps: defaultButtonProps,
            active: active,
            disabled: disabled,
            size: size,
            variant: variant,
            color: color
          }) : {}), {
            effect: function effect(_ref) {
              var actions = _ref.actions;
              _this3.buttonRef.current.actions = actions;
            },
            icon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null),
            IconContainerComponent: function IconContainerComponent(_ref2) {
              var children = _ref2.children,
                active = _ref2.active,
                disabled = _ref2.disabled,
                size = _ref2.size,
                variant = _ref2.variant,
                color = _ref2.color,
                props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
              return /*#__PURE__*/_react["default"].createElement("div", props, active ? /*#__PURE__*/_react["default"].createElement(_DoneIcon["default"], null) : /*#__PURE__*/_react["default"].createElement(_CloseIcon["default"], null));
            }
          }));
        }
      })));
    }
  }]);
}(_react.Component);
function SwitchMenuItem(props) {
  var colorContext = (0, _react.useContext)(_context3["default"]);
  var _props$MenuItemCompon = props.MenuItemComponent,
    MenuItemComponent = _props$MenuItemCompon === void 0 ? _MenuItem["default"] : _props$MenuItemCompon,
    active = props.active,
    _props$color = props.color,
    color = _props$color === void 0 ? colorContext.color : _props$color,
    effect = props.effect,
    switchClassNames = props.switchClassNames,
    switchIconToEnd = props.switchIconToEnd,
    getSwitchIconButtonProps = props.getSwitchIconButtonProps,
    getSwitchIconParentButtonProps = props.getSwitchIconParentButtonProps,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var buttonRef = (0, _react.useRef)();
  var switchIconActions = (0, _react.useRef)({});
  var _useState = (0, _react.useState)(active),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _active = _useState2[0],
    _setActive2 = _useState2[1];
  var SwitchIconW = (0, _react.useMemo)(function () {
    return function (props) {
      return /*#__PURE__*/_react["default"].createElement(SwitchIcon, Object.assign({}, props, {
        classNames: switchClassNames,
        effect: function effect(p) {
          var actions = p.actions;
          switchIconActions.current.actions = actions;
          if (props.effect) {
            props.effect(p);
          }
        },
        getSwitchIconButtonProps: getSwitchIconButtonProps,
        getSwitchIconParentButtonProps: getSwitchIconParentButtonProps
      }));
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (effect && buttonRef.current) {
      effect((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current), {}, {
        actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current.actions), {}, {
          setActive: function () {
            var _setActive3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(value) {
              var _buttonRef$current$ac, _switchIconActions$cu;
              var _switchIconActions$cu2;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return _setActive2(value);
                  case 2:
                    if ((_buttonRef$current$ac = buttonRef.current.actions) !== null && _buttonRef$current$ac !== void 0 && _buttonRef$current$ac.setActive) {
                      buttonRef.current.actions.setActive(value);
                    }
                    if ((_switchIconActions$cu = switchIconActions.current.actions) !== null && _switchIconActions$cu !== void 0 && _switchIconActions$cu.setActive) {
                      (_switchIconActions$cu2 = switchIconActions.current.actions) === null || _switchIconActions$cu2 === void 0 ? void 0 : _switchIconActions$cu2.setActive(value);
                    }
                  case 4:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            function setActive(_x2) {
              return _setActive3.apply(this, arguments);
            }
            return setActive;
          }()
        })
      }));
    }
    return function () {
      effect((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current ? buttonRef.current : {}), {}, {
        actions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, buttonRef.current.actions ? buttonRef.current.actions : {}), {}, {
          setActive: function setActive() {}
        })
      }));
    };
  });
  (0, _react.useEffect)(function () {
    if (active !== _active) {
      var _switchIconActions$cu3;
      _setActive2(active);
      if ((_switchIconActions$cu3 = switchIconActions.current.actions) !== null && _switchIconActions$cu3 !== void 0 && _switchIconActions$cu3.setActive) {
        var _switchIconActions$cu4;
        (_switchIconActions$cu4 = switchIconActions.current.actions) === null || _switchIconActions$cu4 === void 0 ? void 0 : _switchIconActions$cu4.setActive(active);
      }
    }
  }, [active]);
  return /*#__PURE__*/_react["default"].createElement(MenuItemComponent, Object.assign({}, rest, switchIconToEnd ? {
    EndIconContainerComponent: SwitchIconW,
    endIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
  } : {
    StartIconContainerComponent: SwitchIconW,
    startIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
  }, {
    active: _active,
    color: color,
    effect: function effect(p) {
      buttonRef.current = p;
    }
  }));
}
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (_props, ref) {
  var _props$MenuItemProps = _props.MenuItemProps,
    MenuItemProps = _props$MenuItemProps === void 0 ? {} : _props$MenuItemProps,
    MenuItemComponent = _props.MenuItemComponent,
    classNames = _props.classNames,
    checkboxIconToEnd = _props.checkboxIconToEnd,
    switchIconToEnd = _props.switchIconToEnd,
    getSwitchIconButtonProps = _props.getSwitchIconButtonProps,
    getSwitchIconParentButtonProps = _props.getSwitchIconParentButtonProps,
    props = (0, _objectWithoutProperties2["default"])(_props, _excluded4);
  return /*#__PURE__*/_react["default"].createElement(_CheckboxBase["default"], Object.assign({}, props, {
    classNames: classNames,
    ref: ref,
    MenuItemComponent: MenuItemComponent || SwitchMenuItem,
    MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      switchClassNames: classNames,
      disableForceUpdateForIcons: true
    }, MenuItemProps ? MenuItemProps : {}), {}, {
      switchIconToEnd: switchIconToEnd,
      getSwitchIconButtonProps: getSwitchIconButtonProps,
      getSwitchIconParentButtonProps: getSwitchIconParentButtonProps
    }),
    checkboxIconToEnd: switchIconToEnd
  }));
});